// extracted by mini-css-extract-plugin
export default {"no_order_part":"noOrder_no_order_part__4C+Lw","no_order":"noOrder_no_order__8JEZB"};